import { InfoIcon } from '@/components_deprecated/icons/icons/info-icon'
import { InfoModal } from '@/components_deprecated/InfoModal/InfoModal'
import type { PageType } from '@/modules/common/consts'
import { INFO_CONTENT_QUERY } from '@/modules/common/queries'
import { useQuery } from '@apollo/client'
import { useLocale } from '@ur-solutions/react-hooks'
import { useState } from 'react'
import styled from 'styled-components'

const InfoButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`

export function useInfoModal(page?: PageType) {
  const { locale } = useLocale()

  const [isInfoModalOpen, setIsInfoModalOpen] = useState<boolean>(false)

  const { data: infoData } = useQuery(INFO_CONTENT_QUERY, {
    skip: !page,
    variables: {
      page: page ?? '',
      language: locale,
    },
  })

  const infoContent = infoData?.infoContent

  function handleInfoClick() {
    setIsInfoModalOpen(true)
  }

  const InfoModalComponent = () =>
    !infoContent ? null : (
      <InfoModal
        open={isInfoModalOpen}
        content={infoContent}
        onClose={() => setIsInfoModalOpen(false)}
      />
    )

  const InfoButtonComponent = () =>
    !infoContent ? null : (
      <InfoButton onClick={handleInfoClick}>
        <InfoIcon />
      </InfoButton>
    )

  return {
    infoContent,
    isInfoModalOpen,

    InfoButton: InfoButtonComponent,
    InfoModal: InfoModalComponent,
    handleInfoClick,
  }
}
